import { render, staticRenderFns } from "./ConsentData.vue?vue&type=template&id=bdf55b9c&"
import script from "./ConsentData.vue?vue&type=script&lang=js&"
export * from "./ConsentData.vue?vue&type=script&lang=js&"
import style0 from "./ConsentData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports